import { playMusic } from "../components/videoRecorderAndAudio";

const splash = <HTMLDivElement>document.querySelector(".splash");
const splashH1 = <HTMLDivElement>document.querySelector(".splash h1");
const footerSplash = <HTMLDivElement>document.querySelector(".footerSplash");
const splashPrompt = <HTMLDivElement>document.querySelector(".splashPrompt");
const photofeature = <HTMLDivElement>document.querySelector(".photofeature");
const shopPage = <HTMLDivElement>document.querySelector(".shopPage");
const learnMorePage = <HTMLDivElement>document.querySelector(".learnMorePage");
const downloadPage = <HTMLDivElement>document.querySelector(".downloadPage");
const loadingPage = <HTMLDivElement>document.querySelector(".loadingPage");
const facePrompt = <HTMLDivElement>document.querySelector(".facePrompt");
const roarPrompt = <HTMLDivElement>document.querySelector(".roarPrompt");
const introRoarPrompt = <HTMLDivElement>document.querySelector(".introRoarPrompt");
const permissionsHand = <HTMLImageElement>document.querySelector(".permissionsHand");
const trollyButtonHand = <HTMLImageElement>document.querySelector(".trollyButtonHand");
const roar = <HTMLImageElement>document.querySelector(".roar");
const cameraButton = <HTMLButtonElement>document.querySelector(".cameraButton");
const cameraButtonText = <HTMLDivElement>document.querySelector(".cameraButton p");
const recordingLoader = <HTMLDivElement>document.querySelector(".recordingLoader");
const downloadImage = <HTMLImageElement>document.querySelector(".downloadImage");
const downloadVideo = <HTMLVideoElement>document.querySelector(".downloadVideo");
const footerMain = <HTMLVideoElement>document.querySelector(".footerMain");
const videoLoader = <HTMLVideoElement>document.querySelector(".videoLoader");

const ripple1 = <HTMLDivElement>document.querySelector(".ripple1");
const ripple2 = <HTMLDivElement>document.querySelector(".ripple2");
const ripple3 = <HTMLDivElement>document.querySelector(".ripple3");

export let cameraButtonStr = "Tap to take a photo<br>or hold to record";

const dinoButtonImage = new URL("../assets/images/dinoStompButton.png", import.meta.url).href;
const elmoButtonImage = new URL("../assets/images/faceFilterButton.png", import.meta.url).href;

let roarPromptHasBeenShown = false;
let hasShownTrollyPrompt = false;
let faceVisible = true; // TEMPORARY

export function hideSplash() {
  splash.style.display = "none";
  splashPrompt.style.display = "none";
}

export function revealSplashPrompt() {
  splashPrompt.style.display = "block";
  footerSplash.style.display = "none";
  splashH1.style.opacity = "0";
  splashPrompt.style.opacity = "1";
  splashPrompt.classList.add("fadeIn");
  permissionsHand.classList.add("handPoint");
  ripple1.classList.add("ripple");
  setTimeout(() => {
    ripple2.classList.add("ripple");
    setTimeout(() => {
      ripple3.classList.add("ripple");
    }, 1000);
  }, 1000);
}

export function revealPhotofeature() {
  photofeature.style.display = "block";
}

export function hidePhotofeature() {
  photofeature.style.display = "none";
}

export function revealShopPage() {
  shopPage.style.display = "block";
}

export function hideShopPage() {
  shopPage.style.display = "none";
}

export function revealLearnMorePage() {
  learnMorePage.style.display = "block";
}

export function hideLearnMorePage() {
  learnMorePage.style.display = "none";
}

export function revealLoadingPage() {
  loadingPage.style.display = "block";
  videoLoader.classList.add("rotate");
}

export function hideLoadingPage() {
  loadingPage.style.display = "none";
  videoLoader.classList.remove("rotate");
}

export function revealDownloadPage(isVid: boolean) {
  downloadPage.style.display = "block";
  downloadVideo.style.display = isVid ? "block" : "none";
  downloadImage.style.display = isVid ? "none" : "block";
}

export function hideDownloadPage() {
  downloadPage.style.display = "none";
  downloadImage.src = "";
  downloadVideo.src = "";



  if (!hasShownTrollyPrompt) {
    hasShownTrollyPrompt = true;
    revealTrollyButtonPrompt();
  }

  playMusic();
}

export function revealIntroRoarPrompt() {
  introRoarPrompt.style.display = "block";
}

export function hideIntroRoarPrompt() {
  introRoarPrompt.style.display = "none";
}

export function revealRoarPrompt() {
  if (faceVisible) {
    roarPrompt.style.display = "block";
  }
}

export function hideRoarPrompt() {
  roarPrompt.style.display = "none";
  roarPromptHasBeenShown = true;
}

export function revealFacePrompt() {
  faceVisible = false;
  hideRoarPrompt();
  facePrompt.style.display = "block";
  cameraButton.style.pointerEvents = "none";
  cameraButton.style.filter = "grayscale(100%)";
}

export function hideFacePrompt() {
  faceVisible = true;
  facePrompt.style.display = "none";
  cameraButton.style.pointerEvents = "auto";
  cameraButton.style.filter = "grayscale(0%)";
}

export function startCameraButtonAnim() {
  cameraButtonText.innerHTML = "<br>Recording...";
  recordingLoader.classList.add("recording");
}

export function stopCameraButtonAnim() {
  recordingLoader.classList.remove("recording");
  cameraButtonText.innerHTML = "Tap to take a photo<br>or hold to record";
  recordingLoader.style.clipPath = "polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)";
}

function revealTrollyButtonPrompt() {
  trollyButtonHand.style.opacity = "1";
  trollyButtonHand.classList.add("handPoint");

  setTimeout(() => {
    hideTrollyButtonPrompt();
  }, 10000);
}

export function hideTrollyButtonPrompt() {
  trollyButtonHand.style.opacity = "0";
  trollyButtonHand.classList.add("fadeOut");
}

export function revealFooterMain() {
  footerMain.style.pointerEvents = "auto";
  footerMain.style.opacity = "1";
}

export function changeCameraButtonTextPhotoOnly() {
  cameraButtonStr = "Tap to take a photo";
  cameraButtonText.innerHTML = cameraButtonStr;
}